import { Component } from '@angular/core';

@Component({
  selector: 'spend-chart-summary',
  styleUrls: ['./spend-chart-summary.component.scss'],
  templateUrl: './spend-chart-summary.component.html'
})
export class SpendChartSummaryComponent {}
